import Content from '@nrdy-marketing-engine/components/src/content';
import { DatoImageProps } from '@nrdy-marketing-engine/components/src/nsp-image';
import clsx from 'clsx';
import Image from 'next/image';
import { useEffect } from 'react';
import { PanelData, PanelStateProps } from '../../@types/panel-data';
import * as interstitialPanelStypes from './interstitial-panel.css';
import * as styles from './shared-styles-panel.css';

interface InterstitialPanelProps extends PanelData, PanelStateProps {
  _modelApiKey: 'panel_interstitial';
  delay: number;
  heading: string;
  image: DatoImageProps;
}

function InterstitialPanel({ delay, heading, image, onNext }: InterstitialPanelProps) {
  useEffect(() => {
    const timer = setTimeout(() => onNext(), delay * 1000);

    return () => clearTimeout(timer);
  }, [delay, onNext]);

  const contentClasses = 'prose-base prose-strong:text-xl sm:prose-strong:text-2xl sm:prose-lg';

  return (
    <div className="mb-auto">
      <Content
        className={clsx(contentClasses, styles.heading)}
        heading={heading}
        headingLevel={1}
      />
      <Image className={interstitialPanelStypes.image} src={image.url} {...image} />
    </div>
  );
}

export default InterstitialPanel;
